import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FlightClass, FlightClassProp } from '../../models/FlightClass';
import { setCabinClass } from '../../redux/currentSearch/actions';
import { withPageContext } from '../../utils/PageContext/PageContext';
import { TrackingUtils } from '../../utils';

export const FlightClassSelector = ({ value, setCabinClass, trackEvent, render }) => {
    const onChange = (newValue) => {
        setCabinClass(newValue);

        if (newValue !== value) {
            trackEvent({
                action: TrackingUtils.ACTION.FLIGHTS,
                label: TrackingUtils.LABEL.cabinClassSelect(newValue),
            });
        }
    };

    return render({ onChange, value });
};

FlightClassSelector.propTypes = {
    setCabinClass: PropTypes.func.isRequired,
    value: FlightClassProp,
    trackEvent: PropTypes.func.isRequired,
    render: PropTypes.func.isRequired,
};

FlightClassSelector.defaultProps = {
    value: FlightClass.TOURIST,
};

const mapStateToProps = ({ currentSearch }) => ({
    value: currentSearch.cabinClass,
});

export const ConnectedFlightClassSelector = connect(mapStateToProps, {
    setCabinClass,
})(withPageContext(FlightClassSelector));
